import React from "react";

import "../../css/loaders.css";

export default class Loader extends React.PureComponent {
	render() {
		let style = {};

		if (this.props.height) {
			style.height = this.props.height + "px";
		}

		if (this.props.width) {
			style.width = this.props.width + "px";
		}

		return (
			<div className="loader-align" style={style}>
				<div className="ajax-loader">
					<div className="blob top" />
					<div className="blob bottom" />
					<div className="blob left" />

					<div className="blob move-blob" />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/utils/Loader.js